'use es6';

import { PIE, DONUT } from 'reporting-data/constants/chartTypes';
export const applyShowTotals = (visualization, report) => {
  const chartType = report.get('chartType');
  const showTotals = report.getIn(['displayParams', 'showTotals']);
  const isSliced = [PIE, DONUT].includes(chartType);
  return isSliced ? visualization.setIn(['style', 'showTotals'], showTotals) : visualization;
};